import { SVGProps } from 'react';
const SvgTiktok = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_917_427)">
      <path
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="black"
      />
      <mask
        id="mask0_917_427"
        style={{
          maskType: 'luminance',
        }}
        maskUnits="userSpaceOnUse"
        x={12}
        y={10}
        width={24}
        height={28}
      >
        <path d="M36 10.5H12V37.5H36V10.5Z" fill="white" />
      </mask>
      <g mask="url(#mask0_917_427)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.4687 10.5C29.9304 14.3317 32.1465 16.6161 35.9995 16.8591V21.1688C33.7666 21.3794 31.8108 20.6747 29.5357 19.3461V27.4064C29.5357 37.6458 17.9682 40.8456 13.3176 33.5062C10.3291 28.7835 12.1591 20.4964 21.7456 20.1642V24.7087C21.0153 24.8223 20.2347 25.0005 19.5211 25.2354C17.3889 25.932 16.18 27.2362 16.5159 29.5369C17.1622 33.9438 25.54 35.2479 24.8433 26.6369V10.5081H29.4687V10.5Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_917_427">
        <rect width={48} height={48} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTiktok;
